window.HtmlSanitizer = {

  escapeHtml: function(text) {
    if (text != null) {
      return text.replace(/&/g, '&amp;')
                 .replace(/"/g, '&quot;')
                 .replace(/</g, '&lt;')
                 .replace(/>/g, '&gt;')
                 .replace(/'/g, "&#039;");
    } else {
      return text;
    }
  },

};
